import React from "react";
import { Container, Row, Col, Card, ListGroup, Image } from "react-bootstrap";
import Header from './Header';
import Footer from './Footer';
import RecentPost from './RecentPost';

const NetBeansShortcuts = () => {
  return (
    <>
    <Header />
    <div className="full-div" id="blog">
    <Container fluid className="main-sec">
      <Row>
        <Col sm={2}></Col>
        <Col sm={7} className="bg-white p-4 shadow mb-3">
          <h1>Mastering NetBeans Shortcut Keys for Faster Development</h1>
          <span className="small text-muted"><b>Publish By:</b> CodeInputs</span>
          
          <Row className="mt-3 text-center">
            <Col md={12}>
              <Image src="/graphics/images/netbeans_shortcuts.png" alt="NetBeans Shortcuts" fluid />
            </Col>
          </Row><br/>
          
          <p className="mt-4 text-dark">NetBeans is a powerful Integrated Development Environment (IDE) widely used by developers for Java, PHP, HTML, and other programming languages. To boost productivity and streamline coding, mastering NetBeans shortcut keys can save time and enhance efficiency. Here’s a comprehensive guide to essential NetBeans shortcut keys that every developer should know.</p>
          
          <h4>Basic Editing Shortcuts</h4>
          <ul>
            <li class="shortli"><strong>Ctrl + C / Ctrl + X / Ctrl + V</strong> – Copy, Cut, and Paste</li>
              <li class="shortli"><strong>Ctrl + Z / Ctrl + Y</strong> – Undo and Redo</li>
              <li class="shortli"><strong>Ctrl + S</strong> – Save the file</li>
              <li class="shortli"><strong>Ctrl + A</strong> – Select all</li>
              <li class="shortli"><strong>Ctrl + F</strong> – Find in the file</li>
              <li class="shortli"><strong>Ctrl + R</strong> – Replace text</li>
              <li class="shortli"><strong>Ctrl + Shift + F</strong> – Find in projects</li>
          </ul>
          
          <h4>Navigation Shortcuts</h4>
          <ul class="shortcut">
            <li class="shortli"><strong>Ctrl + Tab</strong> – Switch between open files</li>
            <li class="shortli"><strong>Ctrl + E</strong> – Close the current file</li>
            <li class="shortli"><strong>Ctrl + Shift + T</strong> – Go to the type (class, interface, or enum)</li>
            <li class="shortli"><strong>Ctrl + Shift + O</strong> – Open a file</li>
            <li class="shortli"><strong>Alt + Left / Right Arrow</strong> – Move between recently viewed files</li>
            <li class="shortli"><strong>Ctrl + G</strong> – Go to a specific line number</li>
        </ul>

        <h4>Code Editing Shortcuts</h4>
        <ul class="shortcut">
            <li class="shortli"><strong>Alt + Shift + F</strong> – Format code</li>
            <li class="shortli"><strong>Ctrl + Space</strong> – Code completion</li>
            <li class="shortli"><strong>Ctrl + Shift + Up / Down Arrow</strong> – Duplicate line up/down</li>
            <li class="shortli"><strong>Alt + Shift + Up / Down Arrow</strong> – Move line up/down</li>
            <li class="shortli"><strong>Ctrl + Shift + I</strong> – Fix imports</li>
            <li class="shortli"><strong>Ctrl + /</strong> – Comment or uncomment line</li>
            <li class="shortli"><strong>Ctrl + Shift + C</strong> – Comment/uncomment selected block</li>
        </ul>

        <h4>Debugging Shortcuts</h4>
        <ul class="shortcut">
            <li class="shortli"><strong>F5</strong> – Start debugging</li>
            <li class="shortli"><strong>F8</strong> – Step over</li>
            <li class="shortli"><strong>F7</strong> – Step into</li>
            <li class="shortli"><strong>Shift + F7</strong> – Step into a method</li>
            <li class="shortli"><strong>Ctrl + F5</strong> – Restart debugging</li>
            <li class="shortli"><strong>Ctrl + Shift + F5</strong> – Stop debugging</li>
            <li class="shortli"><strong>Ctrl + Shift + M</strong> – Toggle breakpoint</li>
        </ul>

        <h4>Refactoring Shortcuts</h4>
        <ul class="shortcut">
            <li class="shortli"><strong>Ctrl + R</strong> – Rename</li>
            <li class="shortli"><strong>Ctrl + Shift + R</strong> – Refactor (Move or Rename)</li>
            <li class="shortli"><strong>Alt + Shift + M</strong> – Extract method</li>
            <li class="shortli"><strong>Alt + Shift + V</strong> – Inline variable</li>
            <li class="shortli"><strong>Ctrl + Shift + U</strong> – Convert text to uppercase/lowercase</li>
        </ul>

        <h4>Miscellaneous Shortcuts</h4>
        <ul class="shortcut">
            <li class="shortli"><strong>Ctrl + Shift + Enter</strong> – Add semicolon at end of line</li>
            <li class="shortli"><strong>Ctrl + Shift + P</strong> – Match bracket</li>
            <li class="shortli"><strong>Ctrl + Shift + L</strong> – Show shortcut keys</li>
            <li class="shortli"><strong>Shift + Esc</strong> – Maximize/restore editor window</li>
        </ul>
          
          <h3>Conclusion</h3>
          <p className="mt-4 text-dark">Mastering these NetBeans shortcuts will significantly improve your workflow and reduce the time spent navigating menus. Whether you are debugging, refactoring, or simply editing code, using shortcuts will make your development process much smoother. Happy coding!</p>
        </Col>
        
        <Col sm={3}>
          <Card className="mb-3 shadow">
            <Card.Body>
              <h4 className="mt-4 head-color">Recent Post</h4>
              <RecentPost />
            </Card.Body>
          </Card>

          <Card className="shadow">
            <Card.Body>
              <h4 className="mt-4 head-color">Recent Comment</h4>
              <p className="text-muted">No Comments to Show</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
    </div>
    <Footer />
    </>
  );
};

export default NetBeansShortcuts;